<label mat-dialog-title 
class="mat-dialog-header">
  <span class="title">Extornar Notas de Venta</span><br />
  <span class="subtitle"
    ><b>Todos los items de despachos listados quedarán anulados</b></span
  >
</label>
<mat-dialog-content>
  <app-data-table
    type="massiveProductRefund"
    [data]="dispatchItemList"
    size="large"
    id='massiveProductRefund'
    (updateInline)="updateQuantityReturned($event)"
    (changeSelect)="changeSelectReason($event)"
  >
  </app-data-table>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button
    mat-stroked-button
    mat-dialog-close
    id="cancelPartialReturned"
    (click)="onClosePartialReturned()"
    class="b-s m-2"
  >
    Cancelar
  </button>
  <button
    mat-flat-button
    (click)="onSubmitPartialReturned()"
    id="submitPartialReturned"
    style="background-color:#c92100;color:white;"
    class="button-primary-event border-box"
  >
    Extornar Pedidos
  </button>
</mat-dialog-actions>

<button
  mat-button
  mat-dialog-close
  id="closePartialReturned"
  (click)="onClosePartialReturned()"
  class="dialog-close"
>
  <mat-icon>close</mat-icon>
</button>
